import  kommuneService from '../../../service/kommuneService'
import simpleVectorLayer from './simpleVectorLayer'

export const fuglebeskyttelsesLayer = simpleVectorLayer.create('Fuglebeskyttelsesområder', kommuneService.fetchFuglebeskyttelsesomraader, 0.05)
export const habitatOmraadeLayer = simpleVectorLayer.create('Habitatområder', kommuneService.fetchHabitatomraader, 0.05)
export const nationalparkLayer = simpleVectorLayer.create('Nationalparker', kommuneService.fetchNationalparker, 0.05)
export const kommuneLayer = simpleVectorLayer.create('Kommuner', kommuneService.fetchKommuner, 0)